/**
 * @generated SignedSource<<93ac3a9dadfcfbb99707d7b3ea20821a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderBookSubFragment$data = {
  readonly asks: ReadonlyArray<{
    readonly price: bigint;
    readonly total: bigint;
    readonly value: bigint;
    readonly virtualTotal: bigint;
    readonly virtualValue: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"OrderBookEntryFragment">;
  }>;
  readonly bids: ReadonlyArray<{
    readonly price: bigint;
    readonly total: bigint;
    readonly value: bigint;
    readonly virtualTotal: bigint;
    readonly virtualValue: bigint;
    readonly " $fragmentSpreads": FragmentRefs<"OrderBookEntryFragment">;
  }>;
  readonly center: bigint | null | undefined;
  readonly id: string;
  readonly spread: bigint | null | undefined;
  readonly " $fragmentType": "OrderBookSubFragment";
};
export type OrderBookSubFragment$key = {
  readonly " $data"?: OrderBookSubFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderBookSubFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualTotal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualValue",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "OrderBookEntryFragment"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderBookSubFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "center",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spread",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinBookEntry",
      "kind": "LinkedField",
      "name": "bids",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinBookEntry",
      "kind": "LinkedField",
      "name": "asks",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FinBook",
  "abstractKey": null
};
})();

(node as any).hash = "dafaaea3d2c4c32123e24369eaafec8f";

export default node;
